<template>
  <StaticPage>
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" class="left-panel hidden lg:flex"><LoginComponent /></el-col>
      <el-col :xs="24" :sm="24" :md="12" class="right-panel"
        ><div class="login-form-container">
          <el-row class="text-center">
            <el-col :span="24">
              <div class="pointer" @click="redirectToLogin">
                <LogoBlue class="lg:hidden text-center" />
              </div>
              <h1 class="mt-15.5">{{ $t('forgetPwMobileReq.header') }}</h1>
            </el-col>
          </el-row>
          <el-row class="mt-15.5">
            <el-col>
              <div class="from_box" v-if="formFlag">
                <el-form :model="mobileForm" ref="mobileForm" :rules="rule">
                  <el-row type="flex" justify="space-between">
                    <el-col :span="10">
                      <CountryCodeSelect
                        v-model="mobileForm.countrycode"
                        name="countrycode"
                        :codes="codes"
                        :label="$t('common.field.countryCode')"
                        @select="handleSelect"
                      />
                    </el-col>
                    <el-col :span="13">
                      <InputForm
                        :label="$t('common.field.phone')"
                        name="mobile"
                        v-model="mobileForm.mobile"
                      ></InputForm>
                    </el-col>
                  </el-row>
                  <div class="btn_item text-center">
                    <el-button class="blue_button" @click="sendSMSCode()" :disabled="codeSent" data-testid="submit">
                      {{
                        codeSent
                          ? $t('forgetPwMobileReq.sentAlready') + '(' + count + ')'
                          : $t('forgetPwMobileReq.getCode')
                      }}
                    </el-button>
                  </div>
                </el-form>
                <el-form :model="mobileForm" ref="smsForm" :rules="ruleSMS" class="mt-10">
                  <InputForm
                    :label="$t('forgetPwMobileReq.loginSMSCode')"
                    name="smsCode"
                    :placeholder="$t('forgetPwMobileReq.loginSmsCodeExpires')"
                    v-model="mobileForm.smsCode"
                  ></InputForm>
                  <div class="btn_item text-center">
                    <el-button class="blue_button" @click="submitForm()" data-testid="submit">
                      {{ $t('common.button.submit') }}
                    </el-button>
                  </div>
                </el-form>
              </div>
            </el-col>
          </el-row>
          <el-row class="text-center mt-15.5">
            <el-col :span="24">
              <ul class="tabs">
                <li>
                  <a :href="`https://${platformUrl}/company/regulation/legal-document/`">{{
                    $t('loginClient.legalDocuments')
                  }}</a>
                </li>
                <li>
                  <a :href="`https://${platformUrl}/files/VT_Mauritius_Privacy_Policy.pdf`">{{
                    $t('loginClient.clientAgreement')
                  }}</a>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div></el-col
      >
    </el-row>
  </StaticPage>
</template>

<script>
import CountryCodeSelect from '@/components/form/CountryCodeSelect';
import { validateNumber } from '@/util/validation';
import { apiReq_reset_get_sms, apiReq_reset_profile_password_mobile } from '@/resource';
import LoginComponent from '@/components/auth/login';
import StaticPage from '@/components/template/StaticPage.vue';
import LogoBlue from '@/assets/images/vt/icons/LogoBlue.vue';
import helper from '@/util/signinHelper';
import authMixin from '@/mixins/auth';
import countryCodeEn from '@/assets/data/countrycode_en.json';
import countryCodeCn from '@/assets/data/countrycode_cn.json';
import { rsa } from '@/util/encrypt';

export default {
  name: 'forgetPassword',
  components: { StaticPage, LogoBlue, LoginComponent, CountryCodeSelect },
  mixins: [authMixin],
  data() {
    return {
      codeSent: false,
      formFlag: true,
      count: '',
      timer: null,
      countryCodeEnJson: countryCodeEn,
      countryCodeCnJson: countryCodeCn,
      codes: [],
      mobileForm: {
        mobile: '',
        countrycode: '',
        smsCode: ''
      },
      rule: {
        countrycode: [
          {
            required: true,
            trigger: 'blur',
            validator: validateNumber
          }
        ],
        mobile: [
          {
            required: true,
            trigger: 'blur',
            validator: validateNumber
          }
        ]
      },
      ruleSMS: {
        smsCode: [{ required: true, message: this.$t('forgetPwMobileReq.formValidation.smsCodeReq'), trigger: 'blur' }]
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.smsForm.validate(valid => {
        if (valid) this.getApiReq_reset_profile_password_mobile();
        else return false;
      });
    },
    countDown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeSent = true;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeSent = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    sendSMSCode() {
      this.$refs.mobileForm.validate(valid => {
        if (valid) this.getApiReq_reset_get_sms();
        else return false;
      });
    },
    handleSelect(item) {
      this.mobileForm.countrycode = item.code;
    },
    getApiReq_reset_get_sms() {
      apiReq_reset_get_sms({
        countryPhoneCode: this.mobileForm.countrycode,
        mobileNumber: rsa(this.mobileForm.mobile)
      }).then(resp => {
        if (resp.data.code === 0) this.countDown();
      });
    },
    getApiReq_reset_profile_password_mobile() {
      apiReq_reset_profile_password_mobile({
        countryPhoneCode: this.mobileForm.countrycode,
        mobileNumber: rsa(this.mobileForm.mobile),
        code: this.mobileForm.smsCode
      }).then(resp => {
        if (resp.data.code === 0) {
          helper.smsCodeLogin(resp.data.data);
        }
      });
    },
    formatValues(dataValue) {
      return dataValue.map(e => {
        const [codeLabel, codeValue] = e.value.split('+');
        return {
          ...e,
          codeValue: `+${codeValue}`,
          codeLabel
        };
      });
    }
  },
  mounted() {
    if (this.lang === 'zh_CN') {
      this.codes = this.formatValues(this.countryCodeCnJson);
    } else {
      this.codes = this.formatValues(this.countryCodeEnJson);
    }
  },
  computed: {
    lang() {
      return this.$store.state.common.lang;
    }
  }
};
</script>

<style lang="scss" scoped>
// @import '@/assets/css/pages/forgetChangePasswordReq.scss';
@import '@/assets/css/pages/login.scss';
</style>
